export default __webpack_public_path__ + "static/media/kuruah-logo-beta.4ddab0af.png";